import * as React from "react";
import { Participant } from "twilio-video";
import { ParticipantInfo } from "./ParticipantInfo";
import { ParticipantTracks } from "./ParticipantTracks";

interface Props {
	participant: Participant;
	isLocalParticipant: boolean;
}
export const ParticipantContainer = ({ participant, isLocalParticipant }: Props) => {
	return (
		<ParticipantInfo isLocalParticipant={isLocalParticipant} participant={participant}>
			<ParticipantTracks isLocalParticipant={isLocalParticipant} participant={participant} />
		</ParticipantInfo>
	);
};
